import { render, staticRenderFns } from "./allocations.vue?vue&type=template&id=10ffa942&scoped=true&"
import script from "./allocations.vue?vue&type=script&setup=true&lang=js&"
export * from "./allocations.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./allocations.vue?vue&type=style&index=0&id=10ffa942&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ffa942",
  null
  
)

export default component.exports